import { PATH_NAME } from "../configs/pathName";
import axiosInstance from "./axiosInstance";

export const startGuestTransaction = async (): Promise<{ transaction_ref: string, id: number }> => {
    const response = await axiosInstance.post(PATH_NAME.API_GUEST_TRANSACTION_START);
    return response.data.result;
  };